




// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// import ApplicationheroImage from "../../../assets/solutions/applicationdevelopment/application.svg";
// import EndPoint from "../../../assets/home/EndPoint/Endpoint2.svg";
// import Daas from "../../../assets/home/EndPoint/Daas.png";
// import slide1BgImg from "../../../assets/home/slide1cloud.png";
// import slide23BgImg from "../../../assets/home/slide2-3_background.png";
// import "../stylesh/HeroHome.css";

// const AUTO_DURATION = 4000;
// const MANUAL_DURATION = 10000;

// const slides = [
//   {
//     title: "Endpoint Security and Data Protection",
//     desc: "With Synectiks, manage endpoint security, remote monitoring, email protection, and backup from a single, unified platform. Eliminate tool sprawl, gain real-time visibility across all devices, and protect critical data with centralized controls designed to grow with your business. Synectiks helps you reduce complexity, improve operational efficiency, and stay firmly in control of your endpoint environment.",
//     image: null,
//     backgroundImage: EndPoint,
//     navigateTo: "/services/endpoint",
//   },
  
//   {
//     title: "Cloud Hosting & Business Continuity",
//     desc: "Designed to keep your operations running - no matter the disruption. Synectiks cloud hosting delivers secure, resilient infrastructure with integrated backup, disaster recovery, ensuring availability, protection, and predictable costs.",
//     // subDesc: "Synectiks cloud hosting delivers secure, resilient infrastructure with integrated backup, disaster recovery, ensuring availability, protection, and predictable costs.",
//     image: null,
//     backgroundImage: slide1BgImg,
//     navigateTo: "/services/infrastructure",
//   },
//   {
//     title: "Desktop as a Service (DaaS)",
//     desc: "Deliver secure Windows and Linux desktops and apps with a fast, familiar user experience, accessible from any device or browser through enterprise-grade encryption, and centralized policy controls. Built for Secure and compliance-focused work environments with end-to-end resilience and data protection.",
//     image: Daas,
//     backgroundImage: slide23BgImg,
//     navigateTo: "/services/daas",
//   },
//   {
//     title: "Application Modernization",
//     desc: "Transform legacy systems into scalable, cloud-ready digital platforms. We modernize architecture, optimize performance, and enable seamless integrations. Reduce technical debt, accelerate delivery, and future-proof your business. Build secure, resilient applications designed for continuous growth.",
//     image: ApplicationheroImage,
//     backgroundImage: slide23BgImg,
//     navigateTo: "/solutions/application-development",
//   },
// ];

// const HeroHome = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [currentDuration, setCurrentDuration] = useState(AUTO_DURATION);
//   const [isPaused, setIsPaused] = useState(false);

//   const timerRef = useRef(null);
//   const timeLeftRef = useRef(AUTO_DURATION);
//   const startTimeRef = useRef(Date.now());
//   const navigate = useNavigate();

//   // Unified reset function
//   const resetTimer = useCallback((newDuration) => {
//     if (timerRef.current) clearTimeout(timerRef.current);
//     timeLeftRef.current = newDuration;
//     setCurrentDuration(newDuration);
//     startTimeRef.current = Date.now();
//   }, []);

//   const handleNextSlide = useCallback(() => {
//     setCurrentSlide((prev) => (prev + 1) % slides.length);
//     resetTimer(AUTO_DURATION);
//   }, [resetTimer]);

//   const handlePrevSlide = (e) => {
//     if (e) e.stopPropagation();
//     setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
//     resetTimer(MANUAL_DURATION);
//   };

//   const handleNextSlideManual = (e) => {
//     if (e) e.stopPropagation();
//     setCurrentSlide((prev) => (prev + 1) % slides.length);
//     resetTimer(MANUAL_DURATION);
//   };

//   const goToSlide = (index, e) => {
//     if (e) e.stopPropagation();
//     setCurrentSlide(index);
//     resetTimer(MANUAL_DURATION);
//   };

//   useEffect(() => {
//     if (isPaused) return;

//     startTimeRef.current = Date.now();
//     timerRef.current = setTimeout(() => {
//       handleNextSlide();
//     }, timeLeftRef.current);

//     return () => {
//       if (timerRef.current) clearTimeout(timerRef.current);
//       // Update how much time was left when unmounting/re-rendering
//       const elapsed = Date.now() - startTimeRef.current;
//       timeLeftRef.current = Math.max(0, timeLeftRef.current - elapsed);
//     };
//     // Adding currentSlide to dependencies ensures the timer restarts 
//     // fresh whenever the slide index changes
//   }, [currentSlide, isPaused, handleNextSlide]);

//   const currentSlideData = slides[currentSlide];

//   return (
//     <section
//       className={`hero-home ${currentSlideData.backgroundImage ? 'has-bg-image' : ''}`}
//       onMouseEnter={() => setIsPaused(true)}
//       onMouseLeave={() => setIsPaused(false)}
//       style={{ cursor: isPaused ? 'grabbing' : 'grab' }}
//     >
//       <div
//         className="hero-background-image"
//         key={`bg-${currentSlide}`}
//         style={{
//           backgroundImage: `url(${currentSlideData.backgroundImage})`,
//           backgroundPosition: currentSlide === 2 ? 'calc(50% + 50px) center' : 'center'
//         }}
//       />

//       <button className="nav-arrow prev" onClick={handlePrevSlide}>&#10094;</button>
//       <button className="nav-arrow next" onClick={handleNextSlideManual}>&#10095;</button>

//       <div className="hero-container split-layout">
//         <div className="hero-content-left animate-calm-fade" key={`text-${currentSlide}`}>
//           <h1 className="hero-title">{currentSlideData.title}</h1>
//           <p className="hero-description">{currentSlideData.desc}</p>
//           {currentSlideData.subDesc && (
//             <p className="hero-subdescription">{currentSlideData.subDesc}</p>
//           )}
//           <div className="action-wrapper">
//             <button className="btn-modern-link" onClick={() => navigate(currentSlideData.navigateTo)}>
//               <span className="btn-text">Learn More</span>
//               <div className="arrow-circle">
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                   <line x1="5" y1="12" x2="19" y2="12"></line>
//                   <polyline points="12 5 19 12 12 19"></polyline>
//                 </svg>
//               </div>
//             </button>
//           </div>
//         </div>

//         {currentSlideData.image && (
//           <div className="hero-image-right animate-calm-slide" key={`img-${currentSlide}`}>
//             <img src={currentSlideData.image} alt={currentSlideData.title} />
//           </div>
//         )}
//       </div>

//       <div className="carousel-dots">
//         {slides.map((_, index) => (
//           <button
//             key={index}
//             className={`dot ${currentSlide === index ? "active" : ""}`}
//             onClick={(e) => goToSlide(index, e)}
//           />
//         ))}
//       </div>

//       <div className="progress-bar-track">
//         <div
//           key={`${currentSlide}-${currentDuration}`}
//           className={`progress-bar-fill ${isPaused ? 'paused' : ''}`}
//           style={{ animationDuration: `${currentDuration}ms` }}
//         />
//       </div>
//     </section>
//   );
// };

// export default HeroHome;
















import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ApplicationheroImage from "../../../assets/solutions/applicationdevelopment/application.svg";
import EndPoint from "../../../assets/home/EndPoint/Endpoint2.svg";
import Daas from "../../../assets/home/EndPoint/Daas.png";
import slide1BgImg from "../../../assets/home/slide1cloud.png";
import slide23BgImg from "../../../assets/home/slide2-3_background.png";
import "../stylesh/HeroHome.css";

const AUTO_DURATION = 4000;
const MANUAL_DURATION = 6000;

const slides = [
  {
    title: "Endpoint Security and Data Protection",
    desc: "With Synectiks, manage endpoint security, remote monitoring, email protection, and backup from a single, unified platform. Eliminate tool sprawl, gain real-time visibility across all devices, and protect critical data with centralized controls designed to grow with your business. Synectiks helps you reduce complexity, improve operational efficiency, and stay firmly in control of your endpoint environment.",
    image: null,
    backgroundImage: EndPoint,
    navigateTo: "/services/endpoint",
  },
  {
    title: "Cloud Hosting & Business Continuity",
    desc: "Designed to keep your operations running - no matter the disruption. Synectiks cloud hosting delivers secure, resilient infrastructure with integrated backup, disaster recovery, ensuring availability, protection, and predictable costs.",
    image: null,
    backgroundImage: slide1BgImg,
    navigateTo: "/services/infrastructure",
  },
  {
    title: "Desktop as a Service (DaaS)",
    desc: "Deliver secure Windows and Linux desktops and apps with a fast, familiar user experience, accessible from any device or browser through enterprise-grade encryption, and centralized policy controls. Built for Secure and compliance-focused work environments with end-to-end resilience and data protection.",
    image: Daas,
    backgroundImage: slide23BgImg,
    navigateTo: "/services/daas",
  },
  {
    title: "Application Modernization",
    desc: "Transform legacy systems into scalable, cloud-ready digital platforms. We modernize architecture, optimize performance, and enable seamless integrations. Reduce technical debt, accelerate delivery, and future-proof your business. Build secure, resilient applications designed for continuous growth.",
    image: ApplicationheroImage,
    backgroundImage: slide23BgImg,
    navigateTo: "/solutions/application-development",
  },
];

const HeroHome = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentDuration, setCurrentDuration] = useState(AUTO_DURATION);
  const [isPaused, setIsPaused] = useState(false);

  const timerRef = useRef(null);
  const timeLeftRef = useRef(AUTO_DURATION);
  const startTimeRef = useRef(Date.now());
  const navigate = useNavigate();

  const resetTimer = useCallback((newDuration) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timeLeftRef.current = newDuration;
    setCurrentDuration(newDuration);
    startTimeRef.current = Date.now();
  }, []);

  const handleNextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    resetTimer(AUTO_DURATION);
  }, [resetTimer]);

  const handlePrevSlide = (e) => {
    if (e) e.stopPropagation();
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    resetTimer(MANUAL_DURATION);
  };

  const handleNextSlideManual = (e) => {
    if (e) e.stopPropagation();
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    resetTimer(MANUAL_DURATION);
  };

  const goToSlide = (index, e) => {
    if (e) e.stopPropagation();
    setCurrentSlide(index);
    resetTimer(MANUAL_DURATION);
  };

  // Logic for the countdown and pause
  useEffect(() => {
    if (isPaused) return;

    startTimeRef.current = Date.now();
    timerRef.current = setTimeout(() => {
      handleNextSlide();
    }, timeLeftRef.current);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      const elapsed = Date.now() - startTimeRef.current;
      timeLeftRef.current = Math.max(0, timeLeftRef.current - elapsed);
    };
  }, [currentSlide, isPaused, handleNextSlide]);

  // Handle Mouse Down (Pause)
  const handleMouseDown = (e) => {
    // Only trigger on left click
    if (e.button === 0) {
      setIsPaused(true);
    }
  };

  // Handle Mouse Up (Resume)
  const handleMouseUp = useCallback(() => {
    setIsPaused(false);
  }, []);

  // Global listener to ensure it resumes even if mouse is released outside the element
  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => window.removeEventListener("mouseup", handleMouseUp);
  }, [handleMouseUp]);

  const currentSlideData = slides[currentSlide];

  return (
    <section
      className={`hero-home ${currentSlideData.backgroundImage ? 'has-bg-image' : ''}`}
      onMouseDown={handleMouseDown}
      style={{ cursor: isPaused ? 'grabbing' : 'grab' }}
    >
      <div
        className="hero-background-image"
        key={`bg-${currentSlide}`}
        style={{
          backgroundImage: `url(${currentSlideData.backgroundImage})`,
          backgroundPosition: currentSlide === 2 ? 'calc(50% + 50px) center' : 'center'
        }}
      />

      <button className="nav-arrow prev" onClick={handlePrevSlide}>&#10094;</button>
      <button className="nav-arrow next" onClick={handleNextSlideManual}>&#10095;</button>

      <div className="hero-container split-layout">
        <div className="hero-content-left animate-calm-fade" key={`text-${currentSlide}`}>
          <h1 className="hero-title">{currentSlideData.title}</h1>
          <p className="hero-description">{currentSlideData.desc}</p>
          {currentSlideData.subDesc && (
            <p className="hero-subdescription">{currentSlideData.subDesc}</p>
          )}
          <div className="action-wrapper">
            <button 
                className="btn-modern-link" 
                onClick={() => navigate(currentSlideData.navigateTo)}
                onMouseDown={(e) => e.stopPropagation()} // Prevent button click from pausing
            >
              <span className="btn-text">Learn More</span>
              <div className="arrow-circle">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </button>
          </div>
        </div>

        {currentSlideData.image && (
          <div className="hero-image-right animate-calm-slide" key={`img-${currentSlide}`}>
            <img src={currentSlideData.image} alt={currentSlideData.title} />
          </div>
        )}
      </div>

      <div className="carousel-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={(e) => goToSlide(index, e)}
            onMouseDown={(e) => e.stopPropagation()} // Prevent dots from pausing
          />
        ))}
      </div>

      <div className="progress-bar-track">
        <div
          key={`${currentSlide}-${currentDuration}`}
          className={`progress-bar-fill ${isPaused ? 'paused' : ''}`}
          style={{ animationDuration: `${currentDuration}ms` }}
        />
      </div>
    </section>
  );
};

export default HeroHome;